import clsx from 'clsx';
import { ChevronDown, ChevronUp } from 'react-feather';

import { Button, CarouselArrowType } from '@vestico/shared';

import style from './CarouselArrow.module.css';

export interface CarouselArrowProps {
  type: CarouselArrowType;
  onClick: () => void;
  hidden?: boolean;
}

export const CarouselArrow = ({ type, onClick, hidden }: CarouselArrowProps) => {
  const previous = type === 'prev';

  return (
    <div className={clsx(style.root, { [style.prev]: previous, [style.next]: !previous, [style.hidden]: hidden })}>
      <Button plain onClick={onClick} content={previous ? <ChevronUp /> : <ChevronDown />} noPadding ariaLabel={previous ? 'previous' : 'next'} />
    </div>
  );
};
